<template>
  <Reference
    :id="value && value.id"
    :value="value"
    :label="title"
    placeholder="Введіть назву проекту"
    :items.sync="items"
    :total-items="totalItems"
    component-name="Project"
    :disabled="disabled"
    :hide-details="true"
    :error-messages="errorMessages"
    @input="$emit('input', $event)"
    @getItems="getItems"
  />
</template>

<script>
import * as projectsApi from "@/projects/backend/projectsApi.js";
import Reference from "@/components/Reference";

export default {
  components: {
    Reference,
  },
  props: {
    label: {
      type: String,
      default: "Проект",
    },
    value: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: Array,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    items: [],
    totalItems: 0,
  }),
  computed: {
    title(){
      if (this.required){
        return `${this.label}*`;
      } else {
        return this.label;
      }
    },
  },
  methods: {
    async getItems({ currentPage, perPage, search }) {
      const { result, totalItems } = await projectsApi.getProjectReferences(
        currentPage,
        perPage,
        search
      );
      this.items = [...this.items, ...result];
      this.totalItems = totalItems;
    },
  },
};
</script>
